import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = {
    mergeCss:true,
    css: css`
    margin-bottom: 15px;
    `,
    variant: "primary",
}

orderUploadStyles.fileUploader = {
    buttonProps: {
        mergeCss:true,
        variant: "primary",
    },
}

orderUploadStyles.cancelUploadButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        float: right;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
}

orderUploadStyles.uploadFileButton = {
    css: css`
        float: right;
        span {
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 2px;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            text-transform: uppercase;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 10px;
                        width: 100%;
                    `,
                    css`
                        margin-left: 15px;
                        width: initial;
                    `,
                ],
                "min",
            )}
    `,
}